"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetBucketLoggingInput = {
    type: "structure",
    required: ["Bucket"],
    members: {
        Bucket: {
            shape: {
                type: "string"
            },
            location: "uri",
            locationName: "Bucket"
        }
    }
};
//# sourceMappingURL=GetBucketLoggingInput.js.map